export const colors = {
  // Primary
  primary: '#0D9488',
  primaryLight: '#ccfbf1',
  primaryDark: '#0f766e',

  // Neutrals
  black: '#000000',
  gray900: '#111827',
  gray700: '#374151',
  gray600: '#4b5563',
  gray500: '#6b7280',
  gray400: '#9ca3af',
  gray200: '#e5e7eb',
  gray100: '#f3f4f6',
  gray50: '#f9fafb',
  white: '#ffffff',

  // Semantic
  error: '#dc2626',
  errorLight: '#fef2f2',
  success: '#16a34a',
  successLight: '#f0fdf4',
  info: '#2563eb',

  // Accent (success screen, highlights)
  accent: '#7c3aed',
  accentDark: '#6d28d9',
  accentLight: '#f5f3ff',
} as const;
